export const AGREEMENT_TYPE = {
  ENTERPRISE: 'enterprise',
  ONE_OFF: 'one_off',
  PASS: 'pass',
}

export const BALANCE_LIMIT_TYPE = {
  POOL: 'pool',
}

export const BRANDING_TYPE = {
  ANY: 'any_branding_type',
  BRANDED: 'branded',
}

export const DOWNLOAD_TYPE = {
  FREE: 'free',
  NORMAL: 'normal',
  ONE_OFF: 'one_off',
  REPEATED: 'repeated',
  TOP_UP: 'top_up',
  RESTRICTED: 'restricted',
}

export const LIMIT_TYPE = {
  COMPANY_LIMIT: 'company_limit',
  DAY_LIMIT: 'day_limit',
  NONE: 'none',
  USER_LIMIT: 'user_limit',
}

export const QUOTA_PERIOD = {
  MONTH: 'month',
}

export const AGREEMENT_TYPES = {
  trial: 'trial',
  trial_branded: 'trial_branded',
  enterprise: 'enterprise',
  enterprise_branded: 'enterprise_branded',
  subscription: 'subscription',
  subscription_branded: 'subscription_branded',
  region: 'region',
  pass: 'pass',
  bundle: 'bundle',
  bundle_branded: 'bundle_branded',
  circle_branded: 'circle_branded',
  circle_onscreen_credits: 'circle_onscreen_credits',
}

export const AGREEMENT_TYPE_MAPPINGS = {
  [AGREEMENT_TYPES.enterprise]: AGREEMENT_TYPES.subscription,
  [AGREEMENT_TYPES.enterprise_branded]: AGREEMENT_TYPES.subscription_branded,
  [AGREEMENT_TYPES.circle_branded]: 'Viory Circle branded',
  [AGREEMENT_TYPES.circle_onscreen_credits]: 'Viory Circle',
}

export const agreementType = type => AGREEMENT_TYPE_MAPPINGS[type] || type

// {
//   can: true,
//   why_not_reason: %i[limit on_request pool_restricted inactive live_restricted],
//   download_type: %i[normal free repeated top_up one_off],
//   allowed_branding_types: %i[clean branded credit],
//   one_off_already_downloaded_branding_types: %i[clean branded],
//   limit_type: %i[day_limit company_limit user_limit none]
// }
